var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-card',[_c('div',{staticClass:"flex justify-around"},[_c('vue-word-cloud',{staticStyle:{"height":"200px","width":"70%"},attrs:{"words":_vm.data,"color":_vm.getColor,"font-family":"KoHo"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }